<template>
  <div class="about-majority-career-wrapper bg-white">
    <Head>
      <Title>{{ $t("about.career.meta.title") }}</Title>
      <Meta
        name="description"
        hid="description"
        :content="$t('about.career.meta.description')"
      />
    </Head>

    <AboutCareerHero
      :title="$t('about.career.hero_title')"
      :body="$t('about.career.hero_description')"
      img="https://majority.imgix.net/web-assets/career/majority-bike-tour.png"
    />
    <AboutCareerJobPositions />
    <AboutOurMission />
    <AboutJoinUs />
  </div>
</template>

<script>
import { careerStore } from '@/store/career'

export default {
  layout: 'default',
  async setup () {
    const cStore = careerStore()
    cStore.generateRandomIndexes()
  }
}
</script>
